/**
 * Adds scroller attribute to data function on any components that use this mixin.
 */



export default {
  /**
   * @returns {{scroller: *}}
   */
  data() {
    return {
      scroller: null
    }
  },
  mounted() {
    let self = this;
    self.scroller = document.getElementsByClassName('main-content')[0];
  },
  methods: {
    scrollTop() {
      let self = this;
      self.scroller.scrollTo(0, 0)
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/ScrollerMixin/index.js